import { useContext } from 'react';
import { DataContext } from 'entries/common/widgets/saved-project-configuration/context';
import { getCookie } from 'utils/cookie.helper';
import { REGION_ID_COOKIE } from 'pages/common/consts/cookies';

export const useRegionMismatch = () => {
  const { data } = useContext(DataContext);

  if (__IS_SERVER__) {
    return {
      isRegionMismatch: true,
    };
  }

  const regionIdFromRemoteProps = data?.regionId?.toString();
  const regionIdFromCookies = getCookie(REGION_ID_COOKIE);
  const isRegionMismatch =
    !regionIdFromRemoteProps || !regionIdFromCookies || regionIdFromRemoteProps !== regionIdFromCookies;

  return {
    isRegionMismatch,
  };
};
